'use strict';

var DataRetrieverConstantsService = function DataRetrieverConstantsService() {
  return {
    MARKET_SCREEN: 'MARKET_SCREEN',
    FLIGHT_SCREEN: 'FLIGHT_SCREEN',
    FLIGHT_MANAGEMENT_MODE: 'FLIGHT_MANAGEMENT_MODE',
    FLIGHT_ANALYSIS_MODE: 'FLIGHT_ANALYSIS_MODE',
    STRATEGY_SCREEN: 'STRATEGY_SCREEN',
    RULE_SCREEN: 'RULE_SCREEN',
    SCHEDULE_CHANGE_SCREEN: 'SCHEDULE_CHANGE_SCREEN',
    DEMAND_TRANSPARENCY_SCREEN: 'DEMAND_TRANSPARENCY_SCREEN',
    MARKET_MODE: 'market',
    MARKET_BOOKINGS_INTAKE_MODE: 'market-bookings-intake',
    MARKET_PRODUCT_GROUP_BOOKINGS_INTAKE_MODE: 'market-product-group-bookings-intake',
    BOOKINGS_INTAKE_MODAL: 'bookings-intake-modal',
    MARKET_POST_DEPARTURE_MODE: 'market-post-departure',
    SPONSOR_FORECAST_MARKET_MODE: 'sponsor-forecast-market',
    SPONSOR_FORECAST_LEG_MODE: 'sponsor-forecast-leg',
    SPONSOR_FORECAST_FLIGHT_MODE: 'sponsor-forecast-flight',
    MARKET_PRODUCT_GROUP_MODE: 'market-product-group',
    MARKET_PRODUCT_GROUP_PROFILE_GRAPH_MODE: 'market-product-group-profile-chart',
    SERVICE_MODE: 'service',
    SERVICE_BOOKINGS_INTAKE_MODE: 'service-bookings-intake',
    SERVICE_MANAGEMENT_BOOKINGS_INTAKE_MODE: 'service-management-bookings-intake',
    SERVICE_SHARE_MODE: 'service-share',
    SERVICE_POST_DEPARTURE_MODE: 'service-post-departure',
    SERVICE_COMPETITOR_FARE_MODE: 'service-competitor-fare',
    MARKET_PRODUCT_COMPETITOR_FARE_MODE: 'market-product-group-competitor-fare',
    FLIGHT_COMPETITOR_FARE_MODE: 'flight-competitor-fare',
    BOOKING_MATRIX_MODE: 'booking-matrix',
    ADJUSTMENT_HISTORY_MODE: 'adjustment-history',
    CLASS_MODE: 'class',
    CLASS_BOOKINGS_INTAKE_MODE: 'class-bookings-intake',
    CLASS_FLIGHT_ANALYSIS: 'class-flight-analysis',
    FLIGHT_CLASS_PROFILE_MODE: 'flight-class-profile-mode',
    SEGMENT_CLASS_MODE: 'segment-classes',
    SEGMENT_CLASS_BOOKINGS_INTAKE_MODE: 'segment-classes-bookings-intake',
    SEGMENT_CLASS_POST_DEPARTURE_MODE: 'segment-classes-post-departure',
    CLASS_POST_DEPARTURE_MODE: 'class-post-departure',
    CABIN_MODE: 'cabin',
    CABIN_DA_MODE: 'cabin-da',
    CABIN_BOOKINGS_INTAKE_MODE: 'cabin-bookings-intake',
    FLIGHT_CABIN_PROFILE_MODE: 'flight-cabin-profile-mode',
    CABIN_DEEP_MODE: 'cabin-deep',
    CABIN_POST_DEPARTURE_MODE: 'cabin-post-departure',
    STRATEGY_LISTING_MODE: 'strategy-listing',
    ALERT_STRATEGY_LISTING_MODE: 'alert-strategy-listing',
    RULE_CUSTOM_STRATEGY_LISTING: 'rule-custom-strategy-listing',
    RULE_CUSTOM_STRATEGY_LISTING_ALERTS: 'rule-custom-strategy-listing-alerts',
    RULE_LISTING_MODE: 'rule-listing',
    ALERT_RULE_LISTING_MODE: 'alert-rule-listing',
    RULE_SCHEDULE_CHANGE_REVIEW_MODE: 'rule-schedule-change-review',
    MULTIMODE_CHARTS: 'multimode-charts',
    DATA_EXTRACT_SCREEN: 'DATA_EXTRACT_SCREEN',
    SCHEDULED_MODE: 'scheduled-mode',
    COMPLETED_MODE: 'completed-mode',
    DEMAND_TRANSPARENCY_UNTRUNCATED_MD_MODE: 'demand-transparency-untruncated-md-mode',
    DEMAND_TRANSPARENCY_INITIAL_FORECAST_PROFILE: 'demand-transparency-initial-forecast-profile',
    DEMAND_TRANSPARENCY_FORECAST_PROFILE_REGULAR: 'demand-transparency-forecast-profile-regular',
    DEMAND_TRANSPARENCY_FORECAST_PROFILE_MAPPED: 'demand-transparency-forecast-profile-mapped',
    DTD_CHART: 'demand-transparency-dtd-chart',
    DTD_MATRIX: 'demand-transparency-dtd-matrix',
    ALL_DATA: 'demand-transparency-all-data',
    FORECAST_DATA: 'demand-transparency-forecast-data',
    DTD_FORECAST_PROFILE_CHART: 'demand-transparency-forecast-profile-chart',
    SYSTEM_STATUS_SCREEN: 'SYSTEM_STATUS_SCREEN',
    ENTITY_SCREEN: 'ENTITY_SCREEN',
    EVENTS_SCREEN: 'EVENTS_SCREEN',
    SYSTEM_STATUS_CONFIGURATION_PARAMETERS_MODE: 'configuration-parameters-mode',
    SYSTEM_STATUS_USER_EXCLUSION_RULES_MODE: 'user-exclusion-rules-mode',
    SYSTEM_STATUS_USER_FBC_EXCLUSION_RULES_MODE: 'user-fbc-exclusion-rules-mode',
    SYSTEM_STATUS_USER_FO_FARE_EXCLUSION_RULES_MODE: 'user-fare-exclusion-rules-mode',
    SYSTEM_STATUS_CONFIGURATION_FO_LINKED_FBC_MODE: 'configuration-linked-fbc-mode',
    SYSTEM_STATUS_CONFIGURATION_FO_MARKETS_MODE: 'configuration-fo-markets-mode',
    SYSTEM_STATUS_CONFIGURATION_FO_CITYAPTS_MODE: 'configuration-fo-cityapts-mode',
    SYSTEM_STATUS_CONFIGURATION_FARE_BUILDER_MODE: 'configuration-fare-builder-mode',
    SYSTEM_STATUS_CONFIGURATION_PARAMETERS_ADVANCED_MODE: 'configuration-parameters-advanced-mode',
    SYSTEM_STATUS_CONFIGURATION_BUDGET_TARGET_MODE: 'configuration-budget-target-mode',
    SYSTEM_STATUS_CONFIGURATION_ENTITY_MODE: 'configuration-entity-mode',
    SYSTEM_STATUS_CONFIGURATION_EVENTS_MODE: 'configuration-events-mode',
    SYSTEM_STATUS_CONFIGURATION_MARKET_ASSIGN_MODE: 'configuration-market-assign-mode',
    SYSTEM_STATUS_CONFIGURATION_FLIGHT_ASSIGN_MODE: 'configuration-flight-assignment-mode',
    SYSTEM_STATUS_CONFIGURATION_LEG_ASSIGN_MODE: 'configuration-leg-assignment-mode',
    SYSTEM_STATUS_CONFIGURATION_FLIGHT_TAG_MODE: 'configuration-flight-tag-mode',
    SYSTEM_STATUS_CONFIGURATION_DISCONTINUED_ROUTES_MODE: 'configuration-discontinued-routes-mode',
    SYSTEM_STATUS_CONFIGURATION_HOST_SHARE_MODE: 'configuration-host-share-mode',
    SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_MODE: 'configuration-market-class-fare-mode',
    SYSTEM_STATUS_CONFIGURATION_MARKET_CLASS_FARE_INFLUENCES_MODE: 'configuration-market-class-fare-influences-mode',
    SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_FLIGHT_MODE: 'configuration-user-defined-ref-data-flight-mode',
    SYSTEM_STATUS_CONFIGURATION_USER_DEFINED_REF_DATA_MARKET_MODE: 'configuration-user-defined-ref-data-market-mode',
    SYSTEM_REOPTIMIZATION_STATUS_MODE: 'system-reoptimization-status-mode',
    SYSTEM_STATUS_DEMAND_REINITIALIZATION_MODE: 'system-status-demand-reinitialization-mode',
    SYSTEM_STATUS_FLIGHT_SENT_MODE: 'status-flight-sent-mode',
    SYSTEM_STATUS_SERVICE_SENT_MODE: 'status-service-sent-mode',
    SYSTEM_STATUS_HISTORY_MODE: 'status-history-mode',
    SYSTEM_STATUS_FIGHT_REOPT_MODE: 'system-status-flight-reopt-mode',
    SYSTEM_STATUS_FARES_REOPT_MODE: 'system-status-fares-reopt-mode',
    SYSTEM_STATUS_OVERBOOKING_MODE: 'system-status-overbooking-mode',
    SYSTEM_STATUS_INTERFACE_STATUS_MODE: 'system-status-interface-status-mode',
    FARES_SCREEN: 'FARES_SCREEN',
    FARES_MODE: 'fares-mode',
    FARES_CHART_MODE: 'fares-chart-mode',
    FARES_AVERAGE_MODE: 'fares-average-mode',
    FARES_PREV_AVERAGE_MODE: 'fares-prev-average-mode',
    MAPPED_FARES_MODE: 'mapped-fares-mode',
    CONTRIBUTING_SERVICES_MODE: 'contributing-services-mode',
    FARES_INVERSION_MODE: 'fares-inversion-mode',
    MAPPED_FARES_INVERSION_MODE: 'mapped-fares-inversion-mode',
    DASHBOARD_SCREEN: 'DASHBOARD_SCREEN',
    MARKET_DASHBOARD_MODE: 'market-dashboard',
    FIM_DASHBOARD_MODE: 'fim-dashboard',
    SEASONALITY_SCREEN: 'SEASONALITY_SCREEN',
    DA_SEASONALITY_SEASON_MODE: 'da-seasonality-season-mode',
    SEASONALITY_DEMAND_MODE: 'seasonality-demand-mode',
    SEASONALITY_SHOW_UP_MODE: 'seasonality-show-up-mode',
    SEASONALITY_POOLED_MODE: 'seasonality-pooled-mode',
    SEASONALITY_UNTRUNCATED_MD_MODE: 'seasonality-untruncated-md-mode',
    SEASONALITY_ANALYSIS_CHART_HISTORICAL: 'seasonality-analysis-chart-historical',
    SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED: 'seasonality-analysis-chart-historical-pooled',
    SEASONALITY_ANALYSIS_CHART_FUTURE: 'seasonality-analysis-chart-future',
    SEASONALITY_ANALYSIS_CHART_FUTURE_POOLED: 'seasonality-analysis-chart-future-pooled',
    SEASONALITY_OFFLINE_CALENDAR_REVIEW: 'seasonality-offline-calendar-review',
    SEASONALITY_DA_HOLIDAY_SPECIAL_EVENT: 'seasonality-dynamic-availability-holiday-and-special-events',
    APPLICABLE_SEASONS: 'applicable-seasons',
    REVIEW_INPUT_DATA_CHART: 'seasonality-review-input-data-chart',
    ROM_ANALYSIS_SCREEN: 'ROM_ANALYSIS_SCREEN',
    ROM_ANALYSIS_LOCO_MODE: 'rom-analysis-loco-mode',
    ROM_ANALYSIS_FLATTENED_SERVICES_MODE: 'rom-analysis-flattened-services-mode',
    ROM_ANALYSIS_SKINNY_SERVICES_MODE: 'rom-analysis-skinny-services-mode',
    ROM_ANALYSIS_SKINNY_SERVICES_REFERENCE_MODE: 'rom-analysis-skinny-services-reference-mode',
    ROM_SUMMARY_SCREEN: 'ROM_SUMMARY_SCREEN',
    ROM_SUMMARY_MODE: 'rom-summary-mode',
    ROM_SUMMARY_REFERENCE_MODE: 'rom-summary-reference-mode',
    ROM_SUMMARY_TOP_OPP_SPILL_MODE: 'rom-summary-top-opp-spill-mode',
    ROM_SUMMARY_TOP_OPP_RECAP_MODE: 'rom-summary-top-opp-recap-mode',
    ROM_ANALYSIS_DEMAND_PAX_MODE: 'rom-analysis-demand-pax-mode',
    USER_MANAGEMENT_SCREEN: 'USER_MANAGEMENT_SCREEN',
    USER_MANAGEMENT_MANAGE_USERS_MODE: 'user-management-manage-users-mode',
    USER_MANAGEMENT_ROLE_MANAGEMENT_MODE: 'user-management-role-management-mode',
    USER_MANAGEMENT_ROLES_MODE: 'user-management-roles-mode',
    USER_MANAGEMENT_MANAGE_ACCESS_REQUESTS_MODE: 'user-management-manage-access-requests-mode',
    USER_MANAGEMENT_DEFAULT_ROLE_VIEW_MODE: 'user-management-default-role-view-mode',
    FLIGHT_CABIN_ALERTS: 'cabin-alerts',
    FLIGHT_CLASS_ALERTS: 'class-alerts',
    FLIGHT_SEGMENT_CLASS_ALERTS: 'segment-classes-alerts',
    FLIGHT_CABIN_ALERTS_CLEAR: 'cabin-alerts-clear',
    FLIGHT_CLASS_ALERTS_CLEAR: 'class-alerts-clear',
    FLIGHT_SEGMENT_CLASS_ALERTS_CLEAR: 'segment-classes-alerts-clear',
    FLIGHT_SUMMARY: 'flight-summary',
    MARKET_SERVICE_ALERTS: 'service-alerts',
    MARKET_PRODUCT_ALERTS: 'market-product-group-alerts',
    MARKET_ALERTS: 'market-alerts',
    MARKET_SERVICE_ALERTS_CLEAR: 'service-alerts-clear',
    MARKET_PRODUCT_ALERTS_CLEAR: 'market-product-group-alerts-clear',
    MARKET_ALERTS_CLEAR: 'market-alerts-clear',
    SERVICE_MANAGEMENT: 'service-management',
    SERVICE_MANAGEMENT_ALERTS: 'service-management-alerts',
    SERVICE_MANAGEMENT_ALERTS_CLEAR: 'service-management-alerts-clear',
    PRICING_ANALYSIS_SCREEN: 'PRICING_ANALYSIS_SCREEN',
    PRICING_ANALYSIS_DEPARTURE_DATES: 'pricing-analysis-departure-dates',
    PRICING_ANALYSIS_SERVICES: 'pricing-analysis-services',
    SURCHARGE_UPLOAD_MODE: 'fares-surcharge-upload-mode',
    PRICING_SUMMARY_SCREEN: 'PRICING_SUMMARY_SCREEN',
    PRICING_SUMMARY_SNAPSHOT_DATES: 'pricing-summary-snapshot-dates',
    PRICING_SUMMARY_FARE_CHANGE: 'pricing-summary-fare-change',
    MARKET_PRODUCT_GROUP_MAPPED_BOOKINGS_MODE: 'market-product-group-mapped-bookings',
    MARKET_MAPPED_BOOKINGS_MODE: 'market-mapped-bookings',
    FARES_BASIS_GROUPS_MODE: 'fares-basis-groups-mode',
    FARES_INTERLINE_FARES_ADJUSTMENT: 'interline-fares-adjustment-mode',
    PROFILE_CHART_ADD_FLIGHT_PANEL_DROPDOWNS: 'profile-chart-add-flight-panel-dropdowns',
    PROFILE_CHART_FLIGHT_CARDS: 'profile-chart-flight-cards',
    ALL_SCREENS: 'ALL_SCREENS',
    GLOBAL_NOTIFICATIONS_MODE: 'global-notifications-mode',
    CALIBRATION_ANALYSIS_SCREEN: 'CALIBRATION_ANALYSIS_SCREEN',
    DEMAND_SHARES_MODE: 'demand-shares-mode',
    DEMAND_SHARES_GRID: 'demand-shares',
    ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN: 'ONLINE_LOGIT_CALIBRATION_REVIEW_SCREEN',
    ONLINE_LOGIT_CALIBRATION_MODE: 'online-logit-calibration-mode',
    ONLINE_LOGIT_CALIBRATION_GRID: 'online-logit-calibration-review',
    MIME_TYPE: {
      JSON: 'application/json',
      FORM_URLENCODED: 'application/x-www-form-urlencoded'
    },
    HTTP_METHOD: {
      GET: 'GET',
      POST: 'POST'
    }
  };
};
DataRetrieverConstantsService.$inject = [];
module.exports = DataRetrieverConstantsService;